(function () {
  'use strict';
  var fields = Array.from(document.querySelectorAll('[data-order-note]'));
  var value = fields.length ? fields[0].value : '';
  var saved = value;
  var queue = Promise.resolve();
  var timer;
  function status(key) {
    document.querySelectorAll('[data-order-note-status]').forEach(function(el) {
      el.textContent = el.dataset[key] || '';
      el.dataset.errorState = String(key === 'error');
    });
  }
  function save() {
    clearTimeout(timer);
    queue = queue.catch(function() {}).then(function() {
      var snapshot = value;
      if (snapshot === saved) return;
      status('saving');
      var root = (window.Shopify && window.Shopify.routes.root) || '/';
      return fetch(root + 'cart/update.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({note:snapshot})})
        .then(function(response) { if (!response.ok) throw new Error('Save failed'); return response.json(); })
        .then(function() { saved = snapshot; if (value === snapshot) status('saved'); })
        .catch(function(error) { status('error'); throw error; });
    });
    return queue;
  }
  window.LIF = window.LIF || {};
  window.LIF.saveOrderNote = save;
  document.addEventListener('input', function(event) {
    if (!event.target.matches('[data-order-note]')) return;
    value = event.target.value;
    fields.forEach(function(field) { if (field !== event.target) field.value = value; });
    clearTimeout(timer);
    timer = setTimeout(function() { save().catch(function() {}); }, 400);
  });
  document.addEventListener('submit', function(event) {
    var form = event.target;
    if (event.defaultPrevented || !form.matches('#cart-form, #drawer-checkout-form')) return;
    if (form.dataset.noteReady === 'true') { delete form.dataset.noteReady; return; } if (value === saved) return;
    event.preventDefault();
    var button = event.submitter;
    save().then(function() {
      form.dataset.noteReady = 'true';
      setTimeout(function() { if (button && button.isConnected) form.requestSubmit(button); else form.requestSubmit(); }, 0);
    }).catch(function() {});
  }, true);
})();
